/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'
import classNames from 'classnames'
import { TRouteName } from 'AppTypes'

import './MainToolbar.css'
import { useDispatch, useSelector } from 'react-redux'
import { setIsLogedIn, setIsLoggingIn, loadUserInfo } from '@store/StaticStore/authSlice'
import { removeAuth } from '@utils/removeAuth'
import { Link } from 'react-router-dom'
import roleConst from '@const/adminRoles'
import { markWaitingForAnswer } from '@features/customer-question/state_management/slices'
import { getNewQuestionCount } from '@store/StaticStore/appSlice'

type Props = {}

const MainToolbar: React.FC<Props> = () => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const { roles } = useSelector(state => state.auth.user)

  useEffect(() => {
    dispatch(loadUserInfo())
    if (roles.includes(roleConst.SuperAdmin) || roles.includes(roleConst.StoreCustomerAdmin)) {
      dispatch(getNewQuestionCount())
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, location])

  const { mainNavBarNewQuestionCount } = useSelector(state => state.app ?? 0)

  const handleLogout = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault()
    removeAuth()
    dispatch(setIsLogedIn(false))
    dispatch(setIsLoggingIn(false))
    history.push('/login')
  }

  const handleRedirect = (route: TRouteName) => {
    history.push(route)
  }

  const handleRedirectCustomerQuestion = async () => {
    await dispatch(markWaitingForAnswer())
    if (roles.includes(roleConst.SuperAdmin) || roles.includes(roleConst.StoreCustomerAdmin)) {
      await dispatch(getNewQuestionCount())
    }
    history.push('/user-question')
  }

  return (
    <nav className="navbar navbar-expand-lg fixed-top">
      <a className="navbar-brand mr-4" href="/"><img src="assets/img/logo.png" alt="" /></a>
      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon" />
      </button>
      <div className="collapse navbar-collapse" id="navbarCollapse">
        <ul className="navbar-nav mr-auto">
          {roles && (roles.includes(roleConst.SuperAdmin) || roles.includes(roleConst.StoreAdmin)) && (
            <li className={classNames({ 'nav-item': true, active: location.pathname === '/' || location.pathname === '/store-list' })}>
              <span className="nav-link" onClick={() => handleRedirect('/store-approval')}>
                <i className="fas fa-store-alt" />
                <span>店舗一覧</span>
              </span>
              <ul className="sub-nav">
                <li>
                  <Link to={{ pathname: '/store-approval', state: { status: '1' } }}>承認待ち一覧</Link>
                </li>
                <li>
                  <Link to={{ pathname: '/store-list', state: { status: '' } }}>店舗管理一覧</Link>
                </li>
                <li>
                  <Link to="/affiliate-list">紹介会社一覧</Link>
                </li>
                <li>
                  <Link to="/store-recommendation">推薦店舗一覧</Link>
                </li>
              </ul>
            </li>
          )}
          {roles && (roles.includes(roleConst.SuperAdmin) || roles.includes(roleConst.StoreManagerAdmin)) && (
            <li className={classNames({ 'nav-item': true, active: location.pathname === '/manager-list' })}>
              <span className="nav-link" onClick={() => handleRedirect('/manager-list')}>
                <i className="fas fa-user-shield" />
                <span>店舗管理者一覧</span>
              </span>
            </li>
          )}
          {roles
            && (roles.includes(roleConst.SuperAdmin)
            || roles.includes(roleConst.VideoSubmissionAdmin)
            || roles.includes(roleConst.VideoManager)
            || roles.includes(roleConst.VideoApprovalAdmin)) && (
            <li className={classNames({ 'nav-item': true, active: location.pathname === '/video-premium-list' })}>
              <span className="nav-link" onClick={() => handleRedirect('/video-premium-list')}>
                <i className="fas fa-play" />
                <span>動画管理</span>
              </span>
              <ul className="sub-nav">
                <li>
                  <Link to="/video-premium-list">プレミアム動画</Link>
                </li>
                <li>
                  <Link to="/support-video">応援動画</Link>
                </li>
                <li>
                  <Link to="/video-premium-list">紹介動画</Link>
                </li>
              </ul>
            </li>
          )}
          {roles && (roles.includes(roleConst.SuperAdmin) || roles.includes(roleConst.SalesAdmin)) && (
            <li className={classNames({ 'nav-item': true, active: (location.pathname === '/charge-management' || location.pathname === '/introductionvideoservice-management' || location.pathname === '/initialsetupservice-management' || location.pathname === '/gmbchargeList') })}>
              <span className="nav-link" onClick={() => handleRedirect('/charge-management')}>
                <i className="fas fa-chart-line" />
                <span>売上管理</span>
              </span>
              <ul className="sub-nav">
                <li>
                  <Link to="/charge-management">売上管理</Link>
                </li>
                <li>
                  <Link to="/invoice-management">請求書支払管理</Link>
                </li>
                <li>
                  <Link to="/introductionvideoservice-management">OPT店舗紹介動画</Link>
                </li>
                <li>
                  <Link to="/initialsetupservice-management">OPT初期設定サポート</Link>
                </li>
                <li>
                  <Link to="/gmbchargeList">OPT GMBS連携</Link>
                </li>
              </ul>
            </li>
          )}
          {roles && (roles.includes(roleConst.SuperAdmin) || roles.includes(roleConst.ArticleAdmin)) && (
            <li className={classNames({ 'nav-item': true, active: (location.pathname === '/notification-list' || location.pathname === '/webnotification-list' || location.pathname === '/topappbanner-list' || location.pathname === '/bottomappbanner-list') })}>
              <span className="nav-link" onClick={() => handleRedirect('/notification-list')}>
                <i className="fas fa-pencil-alt" />
                <span>お知らせ管理</span>
              </span>
              <ul className="sub-nav">
                <li>
                  <Link to="/notification-list">アプリ向けお知らせ</Link>
                </li>
                <li>
                  <Link to="/webnotification-list">ユーザーWebお知らせ</Link>
                </li>
                <li>
                  <Link to="/bannernotification-list">App帯お知らせ</Link>
                </li>
                <li>
                  <Link to="/topappbanner-list">App 上部バナー</Link>
                </li>
                <li>
                  <Link to="/bottomappbanner-list">App 下部バナー</Link>
                </li>
              </ul>
            </li>
          )}
          {roles && (roles.includes(roleConst.SuperAdmin) || roles.includes(roleConst.AdministratorAdmin)) && (
            <li className={classNames({ 'nav-item': true, active: location.pathname === '/administrator-list' })}>
              <span className="nav-link" onClick={() => handleRedirect('/administrator-list')}>
                <i className="fas fa-chalkboard-teacher" />
                <span>GMTS管理者一覧</span>
              </span>
            </li>
          )}
          {roles && (roles.includes(roleConst.SuperAdmin) || roles.includes(roleConst.StoreCustomerAdmin)) && (
            <li className={classNames({ 'nav-item': true, active: location.pathname === '/user-list' })}>
              <span className="nav-link" onClick={() => handleRedirect('/user-list')}>
                <i className="fas fa-users" />
                <span>ユーザー管理</span>
              </span>
              <ul className="sub-nav">
                <li>
                  <Link to="/user-list">ユーザー管理</Link>
                </li>
                <li>
                  <Link to="/ambassador-list">2022アンバサダー投票管理</Link>
                </li>
              </ul>
            </li>
          )}
          {roles && (roles.includes(roleConst.SuperAdmin) || roles.includes(roleConst.StoreAdmin)) && (
            <li className={classNames({ 'nav-item': true, active: location.pathname === '/marks' || location.pathname === '/pagesetup-list' })}>
              <span className="nav-link" onClick={() => handleRedirect('/marks')}>
                <i className="fas fa-cog" />
                <span>設定</span>
              </span>
              <ul className="sub-nav">
                {roles.includes(roleConst.SuperAdmin) && (
                  <li>
                    <Link to="/marks">マーク種別管理</Link>
                  </li>
                )}
                <li>
                  <Link to="/store-marks">店舗マーク管理
                  </Link>
                </li>
                <li>
                  <Link to="/livervideo-pointperperiod-setting">応援動画承認Point設定
                  </Link>
                </li>
                <li>
                  <Link to="/pagesetup-list">Top画面タイル管理
                  </Link>
                </li>
              </ul>
            </li>
          )}
          {roles && (roles.includes(roleConst.SuperAdmin) || roles.includes(roleConst.StoreCustomerAdmin)) && (
            <li className={classNames({ 'nav-item': true, active: location.pathname === '/user-question' })}>
              { mainNavBarNewQuestionCount > 0 && <span className="badge badge-warning badge-pill sticky-top float-right mt-3">{mainNavBarNewQuestionCount}</span>}
              <span className="nav-link" onClick={() => handleRedirectCustomerQuestion()}>
                <i className="fas fa-question" />
                <span>お問合せ管理</span>
              </span>
            </li>
          )}
          <li className={classNames({ 'nav-item': true, active: location.pathname === '/user-profile' })}>
            <span className="nav-link" onClick={() => handleRedirect('/user-profile')}>
              <i className="fas fa-user" />
              <span>管理者情報</span>
            </span>
          </li>
        </ul>
        <div className="logout">
          <a onClick={handleLogout} className="nav-link pr-0" href="#">
            <span>ログアウト</span>
            <i className="fas fa-sign-out-alt" />
          </a>
        </div>
      </div>
    </nav>
  )
}

export default MainToolbar
